<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <div v-if="isHideRevenue">本ページへのアクセス権がありません</div>
    <SimulationTemplate v-if="form !== null && !isHideRevenue" :form="form" />
  </div>
</template>

<script>
import SimulationTemplate from '@/components/Shared/Simulation/SimulationTemplate.vue'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import { mapActions } from 'vuex'
import AdvertiserApi from '@/api/AdvertiserApi'
import { modes } from '@/vuex/modules/simulation/constants'
import {
  SimulationPlanRepository,
  readonlyFormFactory,
} from '@/models/Simulation'
import { Account } from '@/models/Account'

export default {
  name: 'SimulationReadonly',
  components: {
    SimulationTemplate,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      form: null,
      isHideRevenue: undefined,
    }
  },
  computed: {
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  async created() {
    await this.$store.dispatch('account/GET')
    await this.mode(modes.READONLY)
    await this.getFormData()
    this.setIsHideRevenue()
  },
  methods: {
    ...mapActions('simulation', {
      mode: 'MODE',
    }),
    ...mapActions('snackbar', {
      showSnackbar: 'SHOW_SNACKBAR',
    }),
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    async getFormData() {
      const hashId = this.$route.query.hashId
      const simulationPlan = await SimulationPlanRepository.findByHashId(hashId)

      if (simulationPlan.simulationPlan.simulationPlanMenu === undefined) {
        await this.$confirm(
          `本シミュレーションは、無効状態となっております。
          シミュレーションを共有して戴いている、アカウントユーザーへ該当の共有元のシミュレーションについて、
          メニューを再度選択し上書き保存していただくようご依頼下さい。 `,
          {
            onlyOk: true,
            okText: '閉じる',
          },
        )
        // adv所属ならadvのsimulation一覧へ
        if (this.userBelongType === 'advertiser') {
          const advertiser = await AdvertiserApi.fetchAdvertiser(
            this.userBelongId,
          )
          const advertiserId = advertiser.item.id
          const agencyId = advertiser.item.agencyId
          this.$router.push(
            `/agencies/${agencyId}/advertisers/${advertiserId}/simulations`,
          )
          return
        }

        // agc所属ならloginLpのsimulation一覧へ
        this.$router.push('/loginlp/simulations')
        return
      }

      this.form = await readonlyFormFactory(simulationPlan)
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
